import { Component, Input, OnChanges } from '@angular/core';

import { Memoize } from '@libs/src/functions/memoize';
import { filterSeekingAndOfferings } from '@libs/src/goal/account-goal.helper';
import { AccountGoal } from '@libs/src/models/account-goal.model';
import {
  Account,
  AccountGroupMembership,
} from '@libs/src/models/account.model';
import { Group } from '@libs/src/models/group.model';
import { getMembership } from '@main-client/src/app/account/account.helpers';

import get from 'lodash-es/get';

@Component({
  selector: 'app-group-update-goals-prompt',
  templateUrl: './group-update-goals-prompt.component.html',
})
export class GroupUpdateGoalsPromptComponent implements OnChanges {
  @Input() group: Group;
  @Input() user: Account;
  accountGoals: AccountGoal[] = [];
  accountMembership: AccountGroupMembership;

  ngOnChanges() {
    this.accountMembership = getMembership(this.user.groups, this.group._id);
    this.accountGoals = get(
      this.accountMembership,
      'goals',
      [],
    ) as AccountGoal[];
  }

  @Memoize()
  getFilteredSeekingAndOfferings({
    accountGoals,
    accountMembership,
  }: {
    accountGoals: AccountGoal[];
    accountMembership: AccountGroupMembership;
  }) {
    const { seeking, offerings } = filterSeekingAndOfferings(
      accountGoals,
      accountMembership,
    );
    return [...seeking, ...offerings];
  }
}
